import { SET_LOGIN_RESPONSE } from '../actions/loginResonseActions';

const initialState = null

const loginResponseReducer = (state = initialState, action) => {
    switch (action.type) {
      case SET_LOGIN_RESPONSE:
        return action.payload;
      default:
        return state;
    }
  };
  
  export default loginResponseReducer;
  